import React from 'react';
import ReactMarkDown from 'react-markdown';
import cn from 'classnames';
import { useDispatch } from 'react-redux';
import { toggleFlyingButton } from '../../reducers/quiz/quiz.actions';

import styles from './label.module.scss';
import Logo from '../logo/logo';

interface LabelProps {
	domain?: string
	logo?: string
	text?: string
	link?: string
	onClick?: () => void,
	modeAlone?: boolean
}

export default function Label({logo, text, link, domain, onClick, modeAlone}:LabelProps) {
	const nativeText = 'Разработано  \n**Dentolo**';
	const dispatch = useDispatch();

	return (
		<a className={cn(styles.label, {[styles.alone]: modeAlone})} 
			href={link || `https://dentolo.ru?utm_source=${domain}`}
			target='_blank'
			rel="noopener noreferrer"
			onClick={onClick}
			onMouseEnter={() => dispatch(toggleFlyingButton(false))}
			onMouseLeave={() => dispatch(toggleFlyingButton(true))}
		>
			<Logo type='footer' src={logo || 'our'}/>
			<ReactMarkDown 
				source={text || nativeText}
				escapeHtml={false}
				className={styles.name}
			/>
		</a>
	)
}